import { createStyles } from '../../theme/createStyles'
import { css } from '../../theme/stitches.config'

export const useStyles = createStyles(() => ({
    calendar: css({
        width: '100%'
    })
}))
